import { z } from 'zod';
export const FilespaceAdminForSchema = z.union([
    z.literal('all'),
    z.array(z.object({
        filespaceId: z.string(),
    })),
]);
